import React, { Component } from 'react';

import './MeasureItem.css'
export class MeasureItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
        }
        this.addedLayers = [];
        this.updateLayerList = {
            addedLayers: this.addedLayers,
            addLayerToList: (layerInfo)=>{
                this.addedLayers.push(layerInfo);
            },
            removeLayerFromList: (layerInfo)=> {
                for (let i = 0; i < this.addedLayers.length; i++) {
                    let addedLayer = this.addedLayers[i];
                    if (JSON.stringify(addedLayer) === JSON.stringify(layerInfo)) {
                        this.addedLayers.splice(i, 1);// 移除index=i項目
                    }
                }
            }
        }
    }

    componentDidMount() {
    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <div className='measureItem' onClick={this.handleClick}>
                <div>
                    <img src={this.props.data.icon} alt={this.props.data.name} width={24} height={24}/>
                </div>
                <span>{this.props.data.name}</span>
            </div>
        );
    }

    handleClick = () => {
        this.props.handleClick&&this.props.handleClick(this.props.data);
    }    
}